export enum CheckboxSize {
    normal = 'normal',
    small = 'small',
}
